import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { GateInRequest } from "../models/gate-in-request.interface";
import { TableListRequest } from "../models/table-list-request.interface";
import { Observable } from "rxjs";
import { ShippingBill } from "../models/shipping-bill.interface";
import { APIResponse } from "../models/standard-response.interface";

const containerInventoryEndPoint = "v1/containers"
const vehicleInventoryEndPoint = "v1/inventory/trailers"
const cargoItemEndPoint = "v1/import-cargo-items"
const shippingBillEndPoint = "v1/shipping-bill-items"
const leoUpdateEndPoint = "v1/leo-updates";



@Injectable({
  providedIn: "root"  // Ensures the service is available app-wide
})
export class InventoryService {
    private baseUrl: string = environment.apiBaseUrl;

    constructor(private http: HttpClient) {
    }

    getContainerList(tableListRequest: TableListRequest): Observable<APIResponse> {
        return this.http.post<APIResponse>(`${this.baseUrl}/${containerInventoryEndPoint}/list?useNewContract=true`, tableListRequest);
    }

    getContainerById(containerId: string, withItems: boolean = false, includeHoldDetails: boolean = true) {
        return this.http.get(`${this.baseUrl}/${containerInventoryEndPoint}/${containerId}?withItems=${withItems}&includeHoldDetails=${includeHoldDetails}`);
    }

    updateContainer(containerId: string, container: any) {
        return this.http.put(
            `${this.baseUrl}/${containerInventoryEndPoint}/${containerId}`,
            container
        );
    }

    getVehicleList(tableListRequest: TableListRequest) {
        return this.http.post(`${this.baseUrl}/${vehicleInventoryEndPoint}/list`, tableListRequest);
    }

    fetchCargoByDocument(request: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/${cargoItemEndPoint}/fetch-by-document`, request);
    }

    fetchContainerByDocument(request: any): Observable<any> {
        return this.http.post(`${this.baseUrl}/${containerInventoryEndPoint}/fetch-by-document`, request);
    }

    saveShippingBill(shippingBill: ShippingBill): Observable<APIResponse> {
        return this.http.post<APIResponse>(`${this.baseUrl}/${shippingBillEndPoint}`, shippingBill);
    }
    
    fetchShippingBillById(shippingBillId: string): Observable<APIResponse> {
        return this.http.get<APIResponse>(`${this.baseUrl}/${shippingBillEndPoint}/${shippingBillId}`);
    }

    updateShippingBill(shippingBillId: string, shippingBill: ShippingBill): Observable<APIResponse> {
        return this.http.put<APIResponse>(`${this.baseUrl}/${shippingBillEndPoint}/${shippingBillId}`, shippingBill);
    }

    listShippingBill(tableListRequest: TableListRequest): Observable<APIResponse> {
        return this.http.post<APIResponse>(`${this.baseUrl}/${shippingBillEndPoint}/list`, tableListRequest);
    }

    updateLeo(leoUpdateRequestList: any) {
    return this.http.put<APIResponse>(`${this.baseUrl}/${leoUpdateEndPoint}`, leoUpdateRequestList);
    }


}